// assets/edm-bundle-controller.js
// Main Controller - Orchestriert alle Module

// Zentrale Namespace-Definition
window.EdumonBundle = window.EdumonBundle || {};

// Controller - Orchestriert alle Module
window.EdumonBundle.Controller = {
  // PDP Instances (pro Product-ID)
  _pdpInstances: new Map(),
  
  /**
   * Initialize Bundle Builder
   * Called on DOM ready
   */
  init: function() {
    const Utils = window.EdumonBundle.Utils;
    
    Utils.onReady(() => {
      // Initialize PDP version (if #bundle-builder exists)
      this.initPDP();
      
      // Initialize Global version (for Landing Pages)
      this.initGlobal();
    });
    
    // Re-initialize on section load (Shopify theme editor)
    document.addEventListener('shopify:section:load', () => {
      this.initPDP();
      this.initGlobal();
    });
  },
  
  /**
   * Initialize PDP version - REFACTORED WITH MANAGER PATTERN
   * Context7: Manager Pattern - Orchestrates CartManager, MobileManager, DesktopManager
   * AUDIT FIX: Implements cleanup infrastructure, AbortController pattern, idempotency with cleanup
   */
  initPDP: function() {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const State = window.EdumonBundle.State;
    const API = window.EdumonBundle.API;
    const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
    const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    const UIInteractions = window.EdumonBundle.UIInteractions;
    const CartManager = window.EdumonBundle.CartManager;
    const MobileManager = window.EdumonBundle.MobileManager;
    const DesktopManager = window.EdumonBundle.DesktopManager;
    
    const el = document.getElementById(Config.SELECTORS.BUNDLE_BUILDER.replace('#', ''));
    if (!el) return;
    
    // AUDIT FIX: Idempotency with cleanup - check for existing instance and cleanup first
    const instanceData = this._initStateAndConfig(el);
    const instanceId = String(instanceData.productId);
    
    if (this._pdpInstances.has(instanceId)) {
      console.log('[Bundle Builder] Existing instance found, cleaning up before re-init');
      this._cleanupPDPInstance(instanceId);
    }
    
    // Mark as initialized
    const initAttr = Config.DATA_ATTRS.BB_INIT.replace('data-', '').replace('-', '');
    el.setAttribute(Config.DATA_ATTRS.BB_INIT, '1');
    
    // Mark BB as active (disables Sticky Buy-Me)
    document.documentElement.classList.add(Config.CLASSES.HAS_BUNDLE_BUILDER);
    
    // Prevent Sticky Buy-Me from booting
    try {
      window[Config.INIT_FLAGS.STICKY_BUYME_BOOTED] = true;
      const sb = document.getElementById(Config.SELECTORS.STICKY_BUYME.replace('#', ''));
      if (sb) {
        sb.setAttribute('hidden', '');
        sb.setAttribute('aria-hidden', 'true');
        sb.style.display = 'none';
      }
    } catch(e) {}
    
    // ================== PHASE 1 & 2: STATE & UI REFERENCES ==================
    // Collect UI references
    this._collectUIReferences(instanceData);
    
    // Destructure für einfacheren Zugriff
    const { state, tiers, maxSlots, unitPrice, moneyFormat, productId, openCartAfterAdd, FAST_OPEN_MS } = instanceData;
    const { $hint, $slots, $total, $est, $submit, $cards, priceMap, tierBySlot, cardImgByVid } = instanceData;
    
    // AUDIT FIX: Create main AbortController for document-level listeners
    const mainAbortController = new AbortController();
    const mainSignal = mainAbortController.signal;
    
    // Slot-Interactivity (Desktop vs Mobile) - Nutzt UIRender
    const updateSlotInteractivity = () => {
      if (UIRenderShared && UIRenderShared.updateSlotInteractivity) {
        UIRenderShared.updateSlotInteractivity($slots, Utils.isMobile());
      } else if (UIRenderMobile && UIRenderMobile.updateSlotInteractivity) {
        // Fallback for backward compatibility
        UIRenderMobile.updateSlotInteractivity($slots, Utils.isMobile());
      }
    };
    updateSlotInteractivity();
    
    // Body-Klasse für Mobile
    if (Utils.isMobile()) document.body.classList.add(Config.CLASSES.MOBILE_ACTIVE);
    
    // ================== PHASE 3: RENDERING PIPELINE ==================
    // Setup rendering pipeline (wiederverwendbar)
    const rendering = this._setupRenderingPipeline({
      state,
      $slots,
      $cards,
      $hint,
      $total,
      $est,
      $submit,
      tiers,
      priceMap,
      unitPrice,
      moneyFormat,
      tierBySlot,
      cardImgByVid,
      instanceData // Für Mobile Hooks (wird später erweitert)
    });
    
    const { updateUI, markDirty, renderSummaryImmediate } = rendering;
    
    // ================== PHASE 4: CREATE MANAGERS ==================
    // Get mobile elements
    const stickyEl = document.getElementById(Config.SELECTORS.STICKY.replace('#', ''));
    const sheet = document.getElementById(Config.SELECTORS.SHEET.replace('#', ''));
    const scrimGlobal = document.getElementById(Config.SELECTORS.SCrim.replace('#', ''));
    
    // Create CartManager
    const cartManager = CartManager.init({
      productId,
      state,
      tiers,
      maxSlots,
      el,
      updateUI,
      onCartEmpty: () => {
        state.reset();
        updateUI();
        if (mobileManager) {
          mobileManager.setSheetItems({});
          mobileManager.updateSheetQuantities();
          mobileManager.updateSheetSummary();
          mobileManager.updateMilestoneChips(0);
        }
      },
      onMobileLoadingHide: () => {
        if (mobileManager) mobileManager.hideLoading();
      },
      onMobileSheetReset: () => {
        if (mobileManager) {
          mobileManager.setSheetItems({});
          mobileManager.updateSheetQuantities();
          mobileManager.updateSheetSummary();
          mobileManager.updateMilestoneChips(0);
        }
      }
    });
    
    // Create MobileManager
    const mobileManager = MobileManager.init({
      state,
      tiers,
      maxSlots,
      sheet,
      stickyEl,
      scrimGlobal,
      productId,
      openCartAfterAdd,
      FAST_OPEN_MS,
      updateUI,
      markDirty,
      syncCartBundleToState: () => cartManager.syncToCart(),
      loadBundleFromCart: () => cartManager.loadFromCart(),
      getUserClosedDuringSync: () => cartManager.getUserClosedDuringSync()
    });
    
    // Create DesktopManager
    const desktopManager = DesktopManager.init({
      el,
      state,
      $slots,
      $cards,
      maxSlots,
      cardImgByVid,
      updateUI,
      markDirty
    });
    
    // Wrappers for compatibility
    const syncCartBundleToState = () => cartManager.syncToCart();
    const loadBundleFromCartIntoState = () => cartManager.loadFromCart();
    
    // ================== PHASE 5: EVENT LISTENERS ==================
    // Form-Submit-Intercept
    UIInteractions.attachFormIntercept(this, el, syncCartBundleToState, renderSummaryImmediate, openCartAfterAdd);
    
    // AUDIT FIX: Use AbortController for cart:empty event listener
    document.addEventListener('cart:empty', (e) => {
      if (e.detail && e.detail.productId && e.detail.productId !== productId) return;
      console.log('[Bundle Builder] Cart empty event detected - resetting state');
      state.reset();
      updateUI();
      if (mobileManager) {
        mobileManager.setSheetItems({});
        mobileManager.updateSheetQuantities();
        mobileManager.updateSheetSummary();
        mobileManager.updateMilestoneChips(0);
      }
    }, { signal: mainSignal });
    
    // ================== PHASE 6: INITIALIZE MOBILE UI ==================
    // Mobile UI is now handled by MobileManager
    // Initialize mobile UI if on mobile
    if (Utils.isMobile() && mobileManager) {
      mobileManager.buildTicks();
      mobileManager.applySlotNumbers();
      mobileManager.updateSticky();
      mobileManager.gateSticky();
      mobileManager.fixSlotAria();
      
      // Auto-Open Logic
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('trigger_sheet') === 'true') {
        setTimeout(() => {
          if (!mobileManager.isSheetOpen()) {
            mobileManager.openSheet();
            try {
              const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
              window.history.replaceState({path: newUrl}, '', newUrl);
            } catch(e) {}
          }
        }, 300);
      }
    }
    
    // ================== PHASE 7: INITIAL LOAD ==================
    // Load bundle from cart and update UI
    loadBundleFromCartIntoState().then(updateUI);
    
    // ================== PHASE 8: STORE INSTANCE ==================
    // Store managers and essential functions in instanceData for cleanup
    Object.assign(instanceData, {
      // Rendering functions
      updateUI,
      markDirty,
      renderSummaryImmediate,
      
      // Cart functions (wrappers)
      syncCartBundleToState,
      loadBundleFromCartIntoState,
      
      // Mobile functions (wrappers for backward compatibility)
      mobile_openSheet: () => mobileManager?.openSheet(),
      mobile_closeSheet: () => mobileManager?.closeSheet(),
      mobile_updateSticky: () => mobileManager?.updateSticky(),
      mobile_updateSheetSummary: () => mobileManager?.updateSheetSummary(),
      mobile_updateSheetQuantities: () => mobileManager?.updateSheetQuantities(),
      mobile_buildTicks: () => mobileManager?.buildTicks(),
      mobile_applySlotNumbers: () => mobileManager?.applySlotNumbers(),
      mobile_fixSlotAria: () => mobileManager?.fixSlotAria(),
      mobile_gateSticky: () => mobileManager?.gateSticky(),
      updateMilestoneChips: (q) => mobileManager?.updateMilestoneChips(q),
      bbMobileLoadingShow: (text) => mobileManager?.showLoading(text),
      bbMobileLoadingHide: () => mobileManager?.hideLoading(),
      
      // Managers (for cleanup)
      cartManager,
      mobileManager,
      desktopManager,
      
      // AbortController (for cleanup)
      mainAbortController,
      
      // Elements
      sheet,
      stickyEl
    });
    
    this._pdpInstances.set(instanceId, instanceData);
    
    console.log('[Bundle Builder] PDP initialized (Manager Pattern)');
  },
  
  /**
   * Cleanup PDP instance (AUDIT FIX: Memory Hygiene)
   * Disconnects observers, aborts event listeners, destroys managers
   * 
   * @param {string} instanceId - Instance ID (productId as string)
   */
  _cleanupPDPInstance: function(instanceId) {
    const instanceData = this._pdpInstances.get(instanceId);
    if (!instanceData) return;
    
    console.log('[Bundle Builder] Cleaning up PDP instance:', instanceId);
    
    // Destroy managers
    if (instanceData.cartManager && typeof instanceData.cartManager.destroy === 'function') {
      instanceData.cartManager.destroy();
    }
    if (instanceData.mobileManager && typeof instanceData.mobileManager.destroy === 'function') {
      instanceData.mobileManager.destroy();
    }
    if (instanceData.desktopManager && typeof instanceData.desktopManager.destroy === 'function') {
      instanceData.desktopManager.destroy();
    }
    
    // Abort main AbortController
    if (instanceData.mainAbortController) {
      instanceData.mainAbortController.abort();
    }
    
    // Remove from instances map
    this._pdpInstances.delete(instanceId);
    
    console.log('[Bundle Builder] PDP instance cleaned up:', instanceId);
  },
  
  /**
   * Initialize Global version (Landing Pages)
   * Unified Engine Strategy: Uses State + MobileManager (same as PDP)
   */
  initGlobal: function() {
    const Config = window.EdumonBundle.Config;
    
    // Idempotent initialization
    if (document[Config.INIT_FLAGS.GLOBAL_INITIALIZED]) {
      console.log('[Bundle Builder] Already initialized, skipping...');
      return;
    }
    
    const globalSheet = document.getElementById(Config.SELECTORS.SHEET_GLOBAL.replace('#', ''));
    
    if (!globalSheet) {
      console.log('[Bundle Builder] No global sheet found, skipping initialization');
      return;
    }
    
    document[Config.INIT_FLAGS.GLOBAL_INITIALIZED] = true;
    
    // Setup Global Event Delegation (Trigger Handlers)
    this._setupGlobalEventDelegation();
    
    console.log('[Bundle Builder] Global initialized (Unified Engine Strategy)');
  },
  
  // ================== PRIVATE METHODS (Wiederverwendbar für PDP und LP) ==================
  
  /**
   * Setup rendering pipeline
   * Erstellt alle Rendering-Funktionen und gibt sie zurück
   * 
   * @param {Object} instance - Instance object mit state, UI refs, etc.
   * @returns {Object} Rendering functions {updateUI, markDirty, renderSummaryImmediate, scheduleRender}
   */
  _setupRenderingPipeline: function(instance) {
    const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
    const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const { state, $slots, $cards, $hint, $total, $est, $submit, tiers, priceMap, unitPrice, moneyFormat, tierBySlot, cardImgByVid } = instance;
    
    let needsRender = false;
    const scheduleRender = () => {
      if (needsRender) return;
      needsRender = true;
      requestAnimationFrame(() => {
        needsRender = false;
        renderAll();
      });
    };
    
    const renderAll = () => {
      // Context7: Platform Separation - Slots are visible on both platforms
      renderSlots();
      
      // Context7: Platform Separation - Badges are Desktop-only (hidden on mobile via CSS)
      // Only render badges on Desktop to avoid unnecessary DOM manipulation
      if (!Utils.isMobile()) {
        renderBadges();
      }
      
      // Context7: renderSummary is called on BOTH platforms:
      // - Desktop: Renders hint, total, est, submit (visible on desktop)
      // - Mobile: Triggers Mobile Hooks (sticky, sheet summary) via instance callbacks
      // Desktop elements are hidden on mobile via CSS, but hooks must still fire
      renderSummary();
      
      // Context7: Event-Driven Architecture - Dispatch event for Mobile UI sync
      // Migrated from bb-ui-desktop-LEGACY.js scheduleRender()
      document.dispatchEvent(new CustomEvent('bb:render'));
    };
    
    // Context7: Platform-agnostic - Slots exist on both Desktop and Mobile
    const renderSlots = () => {
      if (UIRenderShared && UIRenderShared.renderSlots) {
        UIRenderShared.renderSlots(state, $slots, cardImgByVid, tiers, (idx, tiersParam) => {
          if (UIRenderShared && UIRenderShared.getSlotLabelText) {
            return UIRenderShared.getSlotLabelText(idx, tiersParam || tiers);
          }
          // Fallback
          return UIRenderDesktop.getSlotLabelText(idx, tiersParam || tiers);
        });
      } else if (UIRenderDesktop && UIRenderDesktop.renderSlots) {
        // Fallback for backward compatibility
        UIRenderDesktop.renderSlots(state, $slots, cardImgByVid, tiers, (idx, tiersParam) => UIRenderDesktop.getSlotLabelText(idx, tiersParam || tiers));
      }
    };
    
    // Context7: Desktop-only - Badges are hidden on mobile via CSS (.bb__grid { display:none })
    const renderBadges = () => {
      // Early return if mobile (defensive check, CSS already hides but avoids unnecessary work)
      if (Utils.isMobile()) return;
      UIRenderDesktop.renderBadges(state, $cards);
    };
    
    const computeTierLine = (totalQty) => {
      const nextTier = tiers.find(t => t.qty > totalQty);
      let currentTier = null;
      for (const t of tiers) if (totalQty >= t.qty) currentTier = t;
      if (totalQty === 0) return '';
      if (!currentTier) return nextTier ? `<strong>Noch ${nextTier.qty - totalQty} Booster für ${nextTier.off}% Rabatt.</strong>` : '';
      const base = `<strong>${currentTier.off}% Rabatt</strong> auf alle ausgewählten Booster aktiviert.`;
      if (nextTier) return `${base} <strong>Noch ${nextTier.qty - totalQty} Booster für ${nextTier.off}% Rabatt.</strong>`;
      return base;
    };
    
    const computeHintWithContext = (totalQty) => {
      const inCart = !!state.activeBundleKey;
      const isDirty = state.cartDirty;
      if (totalQty === 0 && inCart && isDirty) return Config.TEXTS.HINT_EMPTY_DIRTY;
      if (totalQty === 0) return Config.TEXTS.HINT_EMPTY;
      if (inCart && !isDirty && totalQty > 0) return Config.TEXTS.HINT_IN_CART(totalQty);
      const tierLine = computeTierLine(totalQty);
      const lines = [];
      if (tierLine) lines.push(tierLine);
      if (isDirty) lines.push(Config.TEXTS.HINT_DIRTY);
      return lines.join('<br/>');
    };
    
    const renderSummary = () => {
      UIRenderDesktop.renderSummary(
        state, tiers, priceMap, unitPrice, moneyFormat, $slots,
        $hint, $total, $est, $submit, computeHintWithContext, tierBySlot
      );
      
      // Mobile Hooks (wenn verfügbar)
      if (typeof instance.mobile_updateSticky === 'function') instance.mobile_updateSticky();
      if (typeof instance.mobile_updateSheetSummary === 'function') instance.mobile_updateSheetSummary();
      if (typeof instance.mobile_updateSheetQuantities === 'function') instance.mobile_updateSheetQuantities();
      if (typeof instance.updateMilestoneChips === 'function') instance.updateMilestoneChips();
    };
    
    const updateUI = () => scheduleRender();
    const markDirty = () => {
      state.markDirty();
      scheduleRender();
    };
    
    const renderSummaryImmediate = () => {
      // Optimistic UI Update
      if ($hint) {
        const optimisticInCart = state.totalQty > 0;
        const optimisticHtml = optimisticInCart 
          ? Config.TEXTS.HINT_IN_CART(state.totalQty)
          : computeHintWithContext(state.totalQty);
        if ($hint.innerHTML !== optimisticHtml) $hint.innerHTML = optimisticHtml;
      }
      
      if ($est) {
        const estSubtotal = Object.entries(state.items)
          .reduce((sum, [vid, qty]) => sum + (priceMap[vid] || unitPrice) * qty, 0);
        const estDiscount = state.tier ? Math.round(estSubtotal * state.tier.off / 100) : 0;
        const estTotal = estSubtotal - estDiscount;
        const html = state.totalQty
          ? `${Utils.fmtMoney(estTotal, moneyFormat)} <span class="bb__est-note">(−${state.tier ? state.tier.off : 0}% voraussichtlich)</span>`
          : '';
        if ($est.innerHTML !== html) $est.innerHTML = html;
      }
      
      // Mobile Hooks (wenn verfügbar)
      if (typeof instance.mobile_updateSticky === 'function') instance.mobile_updateSticky();
      if (typeof instance.mobile_updateSheetSummary === 'function') instance.mobile_updateSheetSummary();
      if (typeof instance.mobile_updateSheetQuantities === 'function') instance.mobile_updateSheetQuantities();
    };
    
    return {
      updateUI,
      markDirty,
      renderSummaryImmediate,
      scheduleRender,
      renderAll,
      renderSlots,
      renderBadges,
      renderSummary
    };
  },
  
  /**
   * Initialize state and config from DOM
   * 
   * @param {Element} el - Bundle builder element
   * @returns {Object} Instance object with state and config
   */
  _initStateAndConfig: function(el) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const State = window.EdumonBundle.State;
    
    const openCartAfterAdd = el.dataset.openCartAfterAdd === 'true';
    const FAST_OPEN_MS = Config.CONSTANTS.FAST_OPEN_MS;
    const tiers = (Utils.safeParseJSON(el.dataset.tiers, Config.DEFAULTS.TIERS) || []).slice().sort((a,b)=>a.qty-b.qty);
    const maxSlots = parseInt(el.dataset.maxSlots || String(Config.CONSTANTS.MAX_SLOTS), 10);
    const unitPrice = parseInt(el.dataset.unitPrice, 10) || 0;
    const moneyFormat = Utils.safeParseJSON(el.dataset.moneyFormat || `"${Config.DEFAULTS.MONEY_FORMAT}"`, Config.DEFAULTS.MONEY_FORMAT);
    const productId = Number(el.dataset.productId);
    
    // State-Instanz erstellen
    const state = State.init(String(productId), {
      productId: productId,
      tiers: tiers,
      maxSlots: maxSlots,
      el: el
    });
    
    return {
      el,
      state,
      tiers,
      maxSlots,
      unitPrice,
      moneyFormat,
      productId,
      openCartAfterAdd,
      FAST_OPEN_MS
    };
  },
  
  /**
   * Normalize product data from API to match Liquid template structure
   * Ensures consistent data format between API and template sources
   * Context7: Single Source of Truth - Template tag is SSOT, API is fallback
   * 
   * @param {Object} apiResponse - Product data from Shopify API
   * @returns {Object} Normalized product data
   */
  _normalizeProductData: function(apiResponse) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    
    // Context7: Single Source of Truth - Extract tiers from metafields
    // Priority: metafields.custom.bundle_tiers.value (JSON string or array)
    let tiers = Config.DEFAULTS.TIERS;
    
    // Check multiple possible paths for bundle_tiers in API response
    const metafields = apiResponse.metafields || apiResponse.metafield || null;
    let bundleTiersValue = null;
    
    if (metafields) {
      // Try custom.bundle_tiers.value (most common)
      if (metafields.custom?.bundle_tiers?.value) {
        bundleTiersValue = metafields.custom.bundle_tiers.value;
      }
      // Try direct metafields array (if API returns array format)
      else if (Array.isArray(metafields)) {
        const bundleTiersMeta = metafields.find(m => 
          (m.namespace === 'custom' && m.key === 'bundle_tiers') ||
          (m.key === 'bundle_tiers' && m.namespace === 'custom')
        );
        if (bundleTiersMeta?.value) {
          bundleTiersValue = bundleTiersMeta.value;
        }
      }
    }
    
    // Parse tiers if found
    if (bundleTiersValue) {
      try {
        if (typeof bundleTiersValue === 'string') {
          tiers = Utils.safeParseJSON(bundleTiersValue, Config.DEFAULTS.TIERS);
        } else if (Array.isArray(bundleTiersValue)) {
          tiers = bundleTiersValue;
        } else {
          tiers = Config.DEFAULTS.TIERS;
        }
        
        // Validate tiers structure
        if (!Array.isArray(tiers) || tiers.length === 0) {
          console.warn('[Bundle Builder] Invalid tiers structure, using defaults');
          tiers = Config.DEFAULTS.TIERS;
        } else {
          // Validate each tier has required properties
          const validTiers = tiers.filter(t => 
            typeof t === 'object' && 
            typeof t.qty === 'number' && 
            typeof t.off === 'number'
          );
          if (validTiers.length !== tiers.length) {
            console.warn('[Bundle Builder] Some tiers are invalid, filtering');
            tiers = validTiers.length > 0 ? validTiers : Config.DEFAULTS.TIERS;
          }
        }
      } catch(e) {
        console.warn('[Bundle Builder] Error parsing bundle_tiers:', e);
        tiers = Config.DEFAULTS.TIERS;
      }
    }
    
    // Log for debugging (can be removed in production)
    if (tiers === Config.DEFAULTS.TIERS) {
      console.log('[Bundle Builder] Using default tiers - metafields not found in API response');
    } else {
      console.log('[Bundle Builder] Using tiers from metafields:', tiers);
    }
    
    // Build imageMap from apiResponse.images array (Shopify AJAX API format)
    const imageMap = new Map();
    if (apiResponse.images && Array.isArray(apiResponse.images)) {
      apiResponse.images.forEach(img => {
        if (img.id && img.src) {
          imageMap.set(img.id, img);
        }
      });
    }
    
    // Normalize variants with proper image mapping
    const variants = (apiResponse.variants || []).map(v => {
      // Create variant object with image lookup
      let variantImage = null;
      let variantImageSrc = '';
      
      // Priority 1: Check if variant has image_id and look it up in imageMap
      if (v.image_id && imageMap.has(v.image_id)) {
        const imageObj = imageMap.get(v.image_id);
        variantImage = imageObj;
        variantImageSrc = imageObj.src || imageObj.url || '';
        
        // CRITICAL: Explicitly assign found image to variant properties
        // This ensures Utils.normalizeImageUrl receives the correct image data
        v.image = variantImageSrc;
        v.featured_image = imageObj; // Assign full image object for compatibility
      }
      
      // Priority 2: Check variant.featured_image (direct image object - rare in AJAX API)
      if (!variantImage && v.featured_image) {
        if (typeof v.featured_image === 'string') {
          variantImageSrc = v.featured_image;
          v.image = variantImageSrc;
        } else if (v.featured_image.src) {
          variantImage = v.featured_image;
          variantImageSrc = v.featured_image.src;
          v.image = variantImageSrc;
        } else if (v.featured_image.url) {
          variantImage = v.featured_image;
          variantImageSrc = v.featured_image.url;
          v.image = variantImageSrc;
        }
      }
      
      // Priority 3: Check variant.featured_media
      if (!variantImage && v.featured_media) {
        if (typeof v.featured_media === 'string') {
          variantImageSrc = v.featured_media;
          v.image = variantImageSrc;
        } else if (v.featured_media.src) {
          variantImage = v.featured_media;
          variantImageSrc = v.featured_media.src;
          v.image = variantImageSrc;
        } else if (v.featured_media.preview?.image) {
          variantImage = v.featured_media.preview.image;
          variantImageSrc = v.featured_media.preview.image.url || v.featured_media.preview.image.src || '';
          v.image = variantImageSrc;
        }
      }
      
      // Debug logging if no variant-specific image found
      if (!variantImageSrc && v.image_id) {
        console.warn('[Bundle Builder] Variant image not found:', {
          variantId: v.id,
          variantTitle: v.title,
          imageId: v.image_id,
          imageMapSize: imageMap.size,
          hasImageInMap: imageMap.has(v.image_id)
        });
      }
      
      // NOW call Utils.normalizeImageUrl with variant that has image explicitly set
      const finalImageUrl = Utils.normalizeImageUrl(v, apiResponse);
      
      return {
        id: v.id,
        title: v.title,
        price: v.price,
        available: v.available,
        image: finalImageUrl, // Final normalized image URL
        featured_media: v.featured_media || null,
        featured_image: variantImage || v.featured_image || null
      };
    });
    
    return {
      id: apiResponse.id,
      title: apiResponse.title,
      handle: apiResponse.handle,
      variants: variants,
      tiers: tiers
    };
  },
  
  /**
   * Handle Landing Page trigger - Unified Engine Strategy
   * Uses State and MobileManager (same as PDP) with visual adaptation
   * 
   * @param {number|string} productId - Product ID
   * @param {string} productHandle - Product handle (required for API)
   */
  _handleLandingPageTrigger: async function(productId, productHandle) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const State = window.EdumonBundle.State;
    const MobileManager = window.EdumonBundle.MobileManager;
    const CartManager = window.EdumonBundle.CartManager;
    const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    const API = window.EdumonBundle.API;
    
    try {
      // Step 1: Fetch Product Data
      // Context7: Single Source of Truth - Template tag is ALWAYS SSOT for tiers
      let productData = null;
      
      // Priority 1: Check template tag (SSOT) - MUST be used for correct tiers
      if (productId) {
        const templateId = Config.SELECTORS.PAYLOAD_TEMPLATE(productId).replace('#', '');
        const template = document.getElementById(templateId);
        if (template) {
          const script = template.querySelector('script[type="application/json"]');
          if (script) {
            try {
              productData = Utils.safeParseJSON(script.textContent, null);
              if (productData) {
                // Context7: Validate tiers from template (SSOT)
                if (productData.tiers && Array.isArray(productData.tiers) && productData.tiers.length > 0) {
                  console.log('[Bundle Builder] Using template tag data (SSOT) for LP:', productId, 'with tiers:', productData.tiers);
                } else {
                  console.warn('[Bundle Builder] Template tag missing or invalid tiers, using defaults');
                  productData.tiers = Config.DEFAULTS.TIERS;
                }
              }
            } catch (e) {
              console.warn('[Bundle Builder] Failed to parse template data, falling back to API', e);
              productData = null; // Reset to ensure API fallback
            }
          } else {
            console.warn('[Bundle Builder] Template tag found but no script element, falling back to API');
          }
        } else {
          console.warn('[Bundle Builder] Template tag not found for product:', productId, '- falling back to API');
        }
      }
      
      // Priority 2: Fetch via API (fallback only - API may not include metafields)
      // Context7: CRITICAL - Shopify AJAX API does NOT include metafields by default!
      // The API endpoint /products/{handle}.js returns basic product data without metafields.
      // Therefore, we MUST rely on template tags as SSOT. API fallback should only be used
      // if template tag is completely missing, and we should warn strongly.
      if (!productData && productHandle) {
        // Robust URL construction with explicit null checks
        const routes = window.Shopify && window.Shopify.routes;
        const root = (routes && routes.root) || '/';
        const cleanRoot = root.endsWith('/') ? root : root + '/';
        // Remove leading slash from path to avoid double slashes
        const path = Config.ROUTES.PRODUCTS_JS(productHandle).replace(/^\//, '');
        const productUrl = `${cleanRoot}${path}`;
        
        console.error('[Bundle Builder] CRITICAL: Template tag not found for product:', productId, '- API fallback will use DEFAULT tiers!');
        console.error('[Bundle Builder] Template tag is REQUIRED for correct tiers. Please ensure template tag exists in Liquid template.');
        console.warn('[Bundle Builder] Fetching product via API (will NOT include metafields):', productUrl);
        
        const response = await fetch(productUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const apiResponse = await response.json();
        productData = this._normalizeProductData(apiResponse);
        
        // Context7: CRITICAL WARNING - API does not include metafields, so tiers will be defaults
        // This is a data integrity issue - template tag MUST be present for correct tiers
        if (productData.tiers === Config.DEFAULTS.TIERS) {
          console.error('[Bundle Builder] API response did NOT include bundle_tiers metafield - using DEFAULT tiers:', Config.DEFAULTS.TIERS);
          console.error('[Bundle Builder] This is INCORRECT! Template tag MUST be added to Liquid template for correct tiers.');
          console.error('[Bundle Builder] Expected template tag ID:', Config.SELECTORS.PAYLOAD_TEMPLATE(productId));
        } else {
          console.warn('[Bundle Builder] API fallback parsed tiers from metafields (unexpected - API usually does not include metafields):', productData.tiers);
        }
      }
      
      if (!productData) {
        throw new Error('No product data available');
      }
      
      // Safety check: Ensure Managers are loaded before initialization
      if (!window.EdumonBundle || !window.EdumonBundle.CartManager || !window.EdumonBundle.MobileManager) {
        console.error('[Bundle Builder] Managers missing! Check Liquid theme includes.', {
          hasEdumonBundle: !!window.EdumonBundle,
          hasCartManager: !!(window.EdumonBundle && window.EdumonBundle.CartManager),
          hasMobileManager: !!(window.EdumonBundle && window.EdumonBundle.MobileManager)
        });
        const showToastFn = (UIRenderShared && UIRenderShared.showToast) 
          ? UIRenderShared.showToast 
          : (UIRenderDesktop && UIRenderDesktop.showToast) 
            ? UIRenderDesktop.showToast 
            : null;
        if (showToastFn) {
          showToastFn(
            'Bundle Builder konnte nicht initialisiert werden. Bitte Seite neu laden.',
            'error'
          );
        }
        return;
      }
      
      // Step 2: Initialize State
      const instanceId = `lp-${productData.id}`;
      const tiers = (productData.tiers || Config.DEFAULTS.TIERS).slice().sort((a,b) => a.qty - b.qty);
      const maxSlots = Config.CONSTANTS.MAX_SLOTS;
      
      // Create temporary element for State (LP doesn't have bundle-builder element)
      const tempEl = document.createElement('div');
      tempEl.id = `bb-temp-${productData.id}`;
      document.body.appendChild(tempEl);
      
      const state = State.init(instanceId, {
        productId: productData.id,
        tiers: tiers,
        maxSlots: maxSlots,
        el: tempEl
      });
      
      // Step 3: Get LP sheet elements
      const sheet = document.getElementById(Config.SELECTORS.SHEET_GLOBAL.replace('#', ''));
      const stickyEl = null; // LP doesn't use sticky bar
      const scrimGlobal = document.getElementById(Config.SELECTORS.SCrim_GLOBAL.replace('#', ''));
      
      if (!sheet) {
        throw new Error('Global sheet element not found');
      }
      
      // Add CSS class to distinguish LP context
      sheet.classList.add('bb-sheet--global-context');
      
      // Step 4: Populate sheet grid with variants and milestones (idempotent)
      const grid = sheet.querySelector('.bb-sheet__grid') || sheet.querySelector('#bb-sheet-global-grid');
      const milestonesContainer = sheet.querySelector(Config.SELECTORS.MILESTONES);
      
      // Populate milestones
      if (milestonesContainer) {
        milestonesContainer.innerHTML = '<span class="bb-chip" data-m="0">0%</span>';
        tiers.forEach(t => {
          const chip = document.createElement('span');
          chip.className = 'bb-chip';
          chip.setAttribute(Config.DATA_ATTRS.M, t.qty);
          chip.textContent = `−${t.off}%`;
          milestonesContainer.appendChild(chip);
        });
      }
      
      if (grid) {
        // Idempotent check: Only populate if not already filled for this product
        if (grid.dataset.filledFor !== String(productData.id)) {
          grid.innerHTML = '';
          const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
          productData.variants.forEach(variant => {
            const tile = UIRenderMobile.createVariantTile(variant, productData);
            grid.appendChild(tile);
          });
          grid.dataset.filledFor = String(productData.id);
        }
      }
      
      // Step 5: Create CartManager callbacks that will use MobileManager (SOT)
      // Context7: SOT - All UI updates go through MobileManager
      // We create these callbacks first, then initialize MobileManager with CartManager callbacks
      // This creates a circular dependency that we resolve by using closures
      let mobileManager = null; // Will be set after initialization
      let cartManager = null; // Will be set after initialization
      
      // Create CartManager callbacks that use MobileManager (will be set after MobileManager init)
      const cartManagerCallbacks = {
        updateUI: () => {
          // Context7: SOT - Use MobileManager methods, not direct UIRenderMobile calls
          if (mobileManager) {
            if (mobileManager.updateSheetQuantities) mobileManager.updateSheetQuantities();
            if (mobileManager.updateSheetSummary) mobileManager.updateSheetSummary();
            if (mobileManager.updateMilestoneChips) mobileManager.updateMilestoneChips();
          }
        },
        onCartEmpty: () => {
          state.reset();
          // Context7: SOT - Use MobileManager for UI updates
          if (mobileManager) {
            if (mobileManager.updateSheetQuantities) mobileManager.updateSheetQuantities();
            if (mobileManager.updateSheetSummary) mobileManager.updateSheetSummary();
            if (mobileManager.updateMilestoneChips) mobileManager.updateMilestoneChips(0);
          }
        },
        onMobileLoadingHide: () => {
          // Context7: SOT - Use MobileManager for loading hide
          if (mobileManager && mobileManager.hideLoading) {
            mobileManager.hideLoading();
          }
        },
        onMobileSheetReset: () => {
          // Handled by MobileManager
        }
      };
      
      // Step 6: Initialize CartManager with MobileManager callbacks (SOT)
      // Context7: SOT - CartManager uses MobileManager for all UI updates
      cartManager = CartManager.init({
        productId: productData.id,
        state,
        tiers,
        maxSlots,
        el: tempEl,
        updateUI: cartManagerCallbacks.updateUI,
        onCartEmpty: cartManagerCallbacks.onCartEmpty,
        onMobileLoadingHide: cartManagerCallbacks.onMobileLoadingHide,
        onMobileSheetReset: cartManagerCallbacks.onMobileSheetReset
      });
      
      // Step 7: Initialize MobileManager with CartManager callbacks (SOT)
      // Context7: Single Source of Truth - MobileManager is the ONLY way to update mobile UI
      // Both PDP and LP use MobileManager, ensuring consistent behavior
      mobileManager = MobileManager.init({
        state,
        tiers,
        maxSlots,
        sheet: sheet, // CRITICAL: Pass global sheet element
        stickyEl: stickyEl,
        scrimGlobal: scrimGlobal,
        productId: productData.id,
        openCartAfterAdd: true,
        FAST_OPEN_MS: Config.CONSTANTS.FAST_OPEN_MS,
        updateUI: () => {
          // Context7: SOT - LP uses MobileManager methods for all UI updates
          if (!mobileManager || !sheet) return;
          
          // Update sheet quantities (variant tiles) - via MobileManager
          if (mobileManager.updateSheetQuantities) {
            mobileManager.updateSheetQuantities();
          }
          
          // Update sheet summary (count, next tier) - via MobileManager
          if (mobileManager.updateSheetSummary) {
            mobileManager.updateSheetSummary();
          }
          
          // Update milestone chips - via MobileManager
          if (mobileManager.updateMilestoneChips) {
            mobileManager.updateMilestoneChips();
          }
        },
        markDirty: () => {
          state.markDirty();
        },
        syncCartBundleToState: () => cartManager.syncToCart(),
        loadBundleFromCart: () => cartManager.loadFromCart(),
        getUserClosedDuringSync: () => cartManager.getUserClosedDuringSync()
      });
      
      // Step 8: Load existing bundle from cart
      await cartManager.loadFromCart();
      
      // Step 9: Update MobileManager's sheet UI to reflect loaded state (SOT)
      // Context7: SOT - All UI updates go through MobileManager
      if (mobileManager.updateSheetQuantities) {
        mobileManager.updateSheetQuantities();
      }
      if (mobileManager.updateSheetSummary) {
        mobileManager.updateSheetSummary();
      }
      if (mobileManager.updateMilestoneChips) {
        mobileManager.updateMilestoneChips();
      }
      
      // Step 10: Hide ALL sticky bars before opening global sheet
      // Context7: SOT - Prevent visual conflicts with multiple sticky elements
      // This ensures clean UX when opening the global sheet on any page
      const bbSticky = document.getElementById('bb-sticky');
      const stickyBuyme = document.getElementById('sticky-buyme');
      if (bbSticky) {
        bbSticky.classList.remove('is-visible');
        bbSticky.setAttribute('aria-hidden', 'true');
      }
      if (stickyBuyme) {
        stickyBuyme.classList.remove('is-visible');
        stickyBuyme.setAttribute('aria-hidden', 'true');
      }
      
      // Step 11: Open sheet
      // DESKTOP LP: Auf Wiedervorlage - Desktop LP wird zur PDP weitergeleitet
      // (siehe _setupGlobalEventDelegation() für Desktop-Erkennung und Weiterleitung)
      // Diese Funktion wird nur noch für Mobile aufgerufen
      mobileManager.openSheet();
      
      // Store instance for cleanup (optional)
      if (!this._lpInstances) {
        this._lpInstances = new Map();
      }
      this._lpInstances.set(instanceId, {
        state,
        mobileManager,
        cartManager,
        tempEl
      });
      
    } catch (error) {
      console.error('[Bundle Builder] Error handling LP trigger:', error);
      const showToastFn = (UIRenderShared && UIRenderShared.showToast) 
        ? UIRenderShared.showToast 
        : (UIRenderDesktop && UIRenderDesktop.showToast) 
          ? UIRenderDesktop.showToast 
          : null;
      if (showToastFn) {
        showToastFn(
          Config.TEXTS.ERROR_LOAD_PRODUCT + (error.message || 'Unbekannter Fehler'),
          'error'
        );
      }
    }
  },
  
  /**
   * Redirect to Product Detail Page (PDP)
   * Used for Desktop LP when Bundle Builder is not available
   * 
   * @param {string} productHandle - Product handle (required for URL construction)
   */
  _redirectToPDP: function(productHandle) {
    if (!productHandle) {
      console.error('[Bundle Builder] Cannot redirect to PDP: productHandle is missing');
      return;
    }
    
    // Construct PDP URL: /products/{handle}
    const routes = window.Shopify && window.Shopify.routes;
    const root = (routes && routes.root) || '/';
    const cleanRoot = root.endsWith('/') ? root : root + '/';
    const pdpUrl = `${cleanRoot}products/${productHandle}`;
    
    console.log('[Bundle Builder] Desktop LP: Redirecting to PDP:', pdpUrl);
    window.location.href = pdpUrl;
  },
  
  /**
   * Collect UI references from DOM
   * 
   * @param {Object} instance - Instance object (wird erweitert)
   */
  _collectUIReferences: function(instance) {
    const Config = window.EdumonBundle.Config;
    const { el, state, tiers, maxSlots } = instance;
    
    const $hint = el.querySelector(Config.SELECTORS.HINT);
    const $slots = Array.from(el.querySelectorAll(Config.SELECTORS.SLOTS));
    const $total = el.querySelector(Config.SELECTORS.TOTAL_QTY);
    const $est = el.querySelector(Config.SELECTORS.ESTIMATED);
    const $submit = el.querySelector(Config.SELECTORS.SUBMIT);
    const $cards = Array.from(el.querySelectorAll(Config.SELECTORS.CARDS));
    
    // Price-Map erstellen
    const priceMap = Object.fromEntries(
      $cards.map(c => [c.dataset.variantId, Number(c.dataset.variantPrice || el.dataset.unitPrice || 0)])
    );
    
    // Tier-by-Slot Map from State (Context7: Single Source of Truth)
    // State.init() already creates tierBySlot map for performance optimization
    const tierBySlot = state.tierBySlot;
    
    // Card-Image-Map für Slot-Rendering
    const cardImgByVid = new Map(
      $cards.map(c => [String(c.dataset.variantId), c.querySelector('img') || null])
    );
    
    // Slot-Labels initialisieren
    const UIRenderDesktop = window.EdumonBundle.UIRenderDesktop;
    const UIRenderMobile = window.EdumonBundle.UIRenderMobile;
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    $slots.forEach(slot => {
      const idx = parseInt(slot.dataset.slot, 10);
      const label = slot.querySelector(Config.SELECTORS.LABEL);
      if (!label) return;
      const labelText = (UIRenderShared && UIRenderShared.getSlotLabelText) 
        ? UIRenderShared.getSlotLabelText(idx, tiers)
        : UIRenderDesktop.getSlotLabelText(idx, tiers);
      label.textContent = labelText;
    });
    
    // Erweitere instance
    instance.$hint = $hint;
    instance.$slots = $slots;
    instance.$total = $total;
    instance.$est = $est;
    instance.$submit = $submit;
    instance.$cards = $cards;
    instance.priceMap = priceMap;
    instance.tierBySlot = tierBySlot;
    instance.cardImgByVid = cardImgByVid;
  },
  
  /**
   * Setup desktop interactions (Card-Clicks, Slot-Clicks)
   * Nur Desktop-Logik, keine Mobile-Checks
   * 
   * @param {Object} instance - Instance object
   * @returns {Object} Desktop interaction functions
   */
  _setupDesktopInteractions: function(instance) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const { el, state, $slots, $cards, maxSlots, cardImgByVid, updateUI, markDirty } = instance;
    
    // Animation (Desktop)
    const flyToSlot = async (fromImg, toSlot) => {
      if (!fromImg || !toSlot) { updateUI(); return; }
      void fromImg.offsetWidth; void toSlot.offsetWidth;
      const imgRect = fromImg.getBoundingClientRect();
      const slotRect = toSlot.getBoundingClientRect();
      if (slotRect.width === 0 || slotRect.height === 0) { updateUI(); return; }
      const ghost = fromImg.cloneNode(true);
      Object.assign(ghost.style, {
        position: 'fixed',
        left: `${imgRect.left}px`,
        top: `${imgRect.top}px`,
        width: `${imgRect.width}px`,
        height: `${imgRect.height}px`,
        zIndex: '9999',
        pointerEvents: 'none',
        willChange: 'transform, opacity'
      });
      document.body.appendChild(ghost);
      const scaleX = slotRect.width / imgRect.width;
      const scaleY = slotRect.height / imgRect.height;
      const dx = slotRect.left - imgRect.left;
      const dy = slotRect.top - imgRect.top;
      try {
        const anim = ghost.animate(
          [{ transform: 'translate(0,0) scale(1)', opacity: 1 },
           { transform: `translate(${dx}px, ${dy}px) scale(${scaleX}, ${scaleY})`, opacity: 1 }],
          { duration: Config.CONSTANTS.ANIMATION_DURATION_MS, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' }
        );
        await anim.finished;
      } catch(e) {} finally {
        ghost.style.willChange = 'auto';
        ghost.remove();
      }
      updateUI();
    };
    
    const firstEmptySlot = () => $slots.find(s => !s.classList.contains(Config.CLASSES.FILLED));
    
    // Card-Clicks (Desktop add)
    // DESKTOP FIX: closest() braucht einen gültigen CSS-Selector mit Punkt
    el.querySelectorAll(Config.SELECTORS.CARD_MEDIA).forEach(cardMedia => {
      const card = cardMedia.closest(Config.SELECTORS.CARDS);
      const vid = card?.dataset.variantId;
      const img = cardMedia.querySelector('img');
      cardMedia.addEventListener('click', async () => {
        if (!vid) {
          console.warn('[Bundle Builder] Desktop: No variant ID found for card', card);
          return;
        }
        if (Object.values(state.items).reduce((a,b)=>a+b,0) >= maxSlots) return;
        const targetSlot = firstEmptySlot();
        if (!targetSlot) {
          console.warn('[Bundle Builder] Desktop: No empty slot found');
          return;
        }
        state.addItem(vid, 1);
        markDirty();
        if (img) await flyToSlot(img, targetSlot);
        else updateUI();
      });
    });
    
    // Slot-Clicks (Desktop remove)
    $slots.forEach(slot => {
      slot.addEventListener('click', () => {
        // Desktop-only: Mobile wird in _setupMobileInteractions behandelt
        if (Utils.isMobile()) return;
        const vid = slot.dataset.variantId;
        if (!vid) return;
        const cur = state.items[vid] || 0;
        if (cur <= 1) {
          state.removeItem(vid);
        } else {
          state.items[vid] = cur - 1;
          state.markDirty();
        }
        const totalQty = Object.values(state.items).reduce((a,b)=>a+b,0);
        if (totalQty > maxSlots) {
          console.warn('[Bundle Builder] Slot click: Total quantity exceeds maximum, capping');
          state.setItems(Utils.capToMaximum(state.items, maxSlots));
        }
        markDirty();
        updateUI();
      });
    });
    
    return { flyToSlot, firstEmptySlot };
  },
  
  /**
   * Load bundle from cart into state
   * Universell für PDP und LP
   * 
   * @param {number} productId - Product ID
   * @param {Object} state - State instance
   * @param {number} maxSlots - Maximum slots
   * @param {Object} sheetItems - Sheet items (optional, for mobile reset)
   * @param {Element} sheet - Sheet element (optional, for mobile reset)
   * @returns {Promise<Object|null>} Bundle group or null
   */
  _loadBundleFromCart: async function(productId, state, maxSlots, sheetItems = null, sheet = null) {
    const API = window.EdumonBundle.API;
    const Utils = window.EdumonBundle.Utils;
    
    // Context7: Use API.loadBundleFromCart() which handles state updates internally
    // This replaces the previous pattern of readExistingBundleGroupOfProduct() + state.loadFromCart()
    const grp = await API.loadBundleFromCart(productId, state, state.activeBundleKey);
    
    // Sheet-UI auf Initial-Zustand zurücksetzen wenn leer
    if (!grp && Utils.isMobile() && sheet && sheetItems) {
      sheetItems = {};
      // Mobile UI wird über instance-Methoden aktualisiert
    }
    return grp;
  },
  
  /**
   * Sync bundle state to cart
   * Universell für PDP und LP
   * 
   * @param {number} productId - Product ID
   * @param {Object} state - State instance
   * @param {Array} tiers - Discount tiers
   * @param {number} maxSlots - Maximum slots
   * @param {Element} el - Bundle builder element
   * @param {Function} updateUI - Update UI function
   * @param {Function} loadBundleFromCart - Load bundle function (for error recovery)
   * @returns {Promise<boolean>} Success status
   */
  _syncBundleToCart: async function(productId, state, tiers, maxSlots, el, updateUI, loadBundleFromCart) {
    const API = window.EdumonBundle.API;
    const Utils = window.EdumonBundle.Utils;
    const Config = window.EdumonBundle.Config;
    
    // Per-instance sync state (verhindert Race-Conditions)
    const instanceId = String(productId);
    if (!this._syncState) this._syncState = new Map();
    const syncState = this._syncState.get(instanceId) || { syncing: false, syncVersion: 0 };
    
    if (syncState.syncing) return false;
    syncState.syncing = true;
    const v = ++syncState.syncVersion;
    this._syncState.set(instanceId, syncState);
    
    const isStale = (version) => version !== syncState.syncVersion;
    
    try {
      // Input validation & maximum enforcement
      const desiredMap = new Map(
        Object.entries(state.items)
          .filter(([,q]) => q > 0)
          .map(([vid,q]) => [Number(vid), q])
      );
      let totalQty = Array.from(desiredMap.values()).reduce((a,b)=>a+b,0);
      
      if (totalQty > maxSlots) {
        console.warn('[Bundle Builder] Total quantity exceeds maximum, capping to', maxSlots);
        const cappedItems = Utils.capToMaximum(state.items, maxSlots);
        state.setItems(cappedItems);
        desiredMap.clear();
        for (const [vid, qty] of Object.entries(state.items).filter(([,q]) => q > 0)) {
          desiredMap.set(Number(vid), qty);
        }
        totalQty = Array.from(desiredMap.values()).reduce((a,b)=>a+b,0);
      }
      
      if (isStale(v)) {
        syncState.syncing = false;
        this._syncState.set(instanceId, syncState);
        return false;
      }
      
      // Tier calculation
      let currentTier = null;
      for (const t of tiers) if (totalQty >= t.qty) currentTier = t;
      const newTierStr = currentTier ? `${currentTier.qty}@${currentTier.off}` : 'none';
      
      // Get current cart state
      const cart = await API.fetchCart();
      if (isStale(v)) {
        syncState.syncing = false;
        this._syncState.set(instanceId, syncState);
        return false;
      }
      
      // Analyze cart: Find all items of this product
      const cartItemsByVariant = new Map();
      for (const item of (cart.items || [])) {
        if (Number(item.product_id) !== productId) continue;
        const vid = Number(item.variant_id);
        const props = item.properties || {};
        const itemBundleKey = props._bundle_key || props.bundle_key || null;
        if (!cartItemsByVariant.has(vid)) cartItemsByVariant.set(vid, []);
        cartItemsByVariant.get(vid).push({
          key: item.key,
          quantity: item.quantity,
          properties: props,
          bundleKey: itemBundleKey
        });
      }
      
      // Determine bundle key
      let bundleKey = state.activeBundleKey || null;
      if (!bundleKey && totalQty > 0) {
        const existing = await API.readExistingBundleGroupOfProduct(productId);
        bundleKey = existing?.bundleKey || `B-${Date.now()}`;
      }
      
      // Calculate diff
      const itemsToAdd = [];
      const updates = {};
      
      for (const [vid, desiredQty] of desiredMap.entries()) {
        const cartLines = cartItemsByVariant.get(vid) || [];
        const linesByBundleKey = new Map();
        for (const line of cartLines) {
          const bkey = line.bundleKey || 'standalone';
          if (!linesByBundleKey.has(bkey)) linesByBundleKey.set(bkey, []);
          linesByBundleKey.get(bkey).push(line);
        }
        
        let bundleLines = [];
        if (bundleKey) {
          const activeBundleLines = linesByBundleKey.get(bundleKey) || [];
          const standaloneLines = linesByBundleKey.get('standalone') || [];
          const otherBundleLines = [];
          for (const [bkey, lines] of linesByBundleKey.entries()) {
            if (bkey !== bundleKey && bkey !== 'standalone') otherBundleLines.push(...lines);
          }
          bundleLines = activeBundleLines.concat(standaloneLines).concat(otherBundleLines);
        } else {
          bundleLines = linesByBundleKey.get('standalone') || [];
        }
        
        bundleLines.sort((a, b) => a.key.localeCompare(b.key));
        const currentQty = bundleLines.reduce((sum, line) => sum + line.quantity, 0);
        const headLine = bundleLines.length > 0 ? bundleLines[0] : null;
        const headHasCorrectProps = headLine && 
          headLine.bundleKey === bundleKey && 
          (headLine.properties?._bundle_tier || headLine.properties?.bundle_tier) === newTierStr;
        
        if (bundleLines.length === 0) {
          itemsToAdd.push({
            id: vid,
            quantity: desiredQty,
            properties: {
              _bundle_key: bundleKey,
              _bundle_tier: newTierStr
            }
          });
        } else if (bundleLines.length === 1 && headHasCorrectProps && currentQty === desiredQty) {
          // Perfect match - skip
        } else {
          for (const line of bundleLines) updates[line.key] = 0;
          itemsToAdd.push({
            id: vid,
            quantity: desiredQty,
            properties: {
              _bundle_key: bundleKey,
              _bundle_tier: newTierStr
            }
          });
        }
      }
      
      // Remove variants
      for (const [vid, cartLines] of cartItemsByVariant.entries()) {
        if (desiredMap.has(vid)) continue;
        const bundleLines = cartLines.filter(line => {
          const lineBundleKey = line.bundleKey || 'standalone';
          const targetBundleKey = bundleKey || 'standalone';
          return lineBundleKey === targetBundleKey;
        });
        for (const line of bundleLines) updates[line.key] = 0;
      }
      
      // Handle other bundles
      if (bundleKey && totalQty > 0) {
        for (const [vid, cartLines] of cartItemsByVariant.entries()) {
          if (desiredMap.has(vid)) continue;
          const otherBundleLines = cartLines.filter(line => {
            const lineBundleKey = line.bundleKey || null;
            return lineBundleKey && lineBundleKey !== bundleKey;
          });
          for (const line of otherBundleLines) updates[line.key] = 0;
        }
      }
      
      // Special case: Remove all items
      if (totalQty === 0) {
        const allProductLines = [];
        for (const lines of cartItemsByVariant.values()) allProductLines.push(...lines);
        for (const line of allProductLines) updates[line.key] = 0;
        itemsToAdd.length = 0;
      }
      
      // Batch execution
      const cartEl = document.querySelector(Config.SELECTORS.CART_NOTIFICATION) || 
                     document.querySelector(Config.SELECTORS.CART_DRAWER);
      const RENDER_SECTIONS = API.getSectionsToRender();
      let finalSections = null;
      
      // Step 1: Update existing items
      if (Object.keys(updates).length > 0) {
        const { data } = await API.cartUpdateWithSections(updates);
        if (isStale(v)) {
          syncState.syncing = false;
          this._syncState.set(instanceId, syncState);
          return false;
        }
        finalSections = data?.sections || null;
      }
      
      // Step 2: Add new items
      if (itemsToAdd.length > 0) {
        const data = await API.cartAdd(itemsToAdd, RENDER_SECTIONS);
        if (isStale(v)) {
          syncState.syncing = false;
          this._syncState.set(instanceId, syncState);
          return false;
        }
        finalSections = data?.sections || finalSections;
      }
      
      // Update properties
      if (bundleKey && totalQty > 0) {
        const freshCart = await API.fetchCart();
        if (isStale(v)) {
          syncState.syncing = false;
          this._syncState.set(instanceId, syncState);
          return false;
        }
        
        const propUpdatePromises = [];
        for (const item of (freshCart.items || [])) {
          if (Number(item.product_id) !== productId) continue;
          if (!desiredMap.has(Number(item.variant_id))) continue;
          const props = item.properties || {};
          const itemBundleKey = props._bundle_key || props.bundle_key || null;
          const itemTier = props._bundle_tier || props.bundle_tier || null;
          const needsKeyUpdate = itemBundleKey !== bundleKey;
          const needsTierUpdate = itemTier !== newTierStr;
          if (needsKeyUpdate || needsTierUpdate) {
            const updatedProps = Object.assign({}, props);
            updatedProps._bundle_key = bundleKey;
            updatedProps._bundle_tier = newTierStr;
            propUpdatePromises.push(API.setLineProps(item.key, updatedProps));
          }
        }
        if (propUpdatePromises.length > 0) await Promise.all(propUpdatePromises);
      }
      
      // Render sections
      if (finalSections) {
        await API.handleSectionsWithVerification({ sections: finalSections }, 'bb-sync');
      } else if (cartEl?.renderContents && Array.isArray(RENDER_SECTIONS) && RENDER_SECTIONS.length) {
        const url = `${window.location.pathname}?sections=${encodeURIComponent(RENDER_SECTIONS.join(','))}`;
        const res2 = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const json2 = await res2.json();
        await API.handleSectionsWithVerification({ sections: json2 }, 'bb-sync-refresh');
      }
      
      // Update state from server
      if (totalQty === 0) {
        state.reset();
      } else {
        state.setActiveBundleKey(bundleKey);
        state.markClean();
      }
      
      if (updateUI) updateUI();
      
      syncState.syncing = false;
      this._syncState.set(instanceId, syncState);
      return true;
      
    } catch (error) {
      console.error('[Bundle Builder] syncCartBundleToState error:', error);
      API.invalidateCache();
      if (loadBundleFromCart) {
        await loadBundleFromCart();
        if (updateUI) updateUI();
      }
      syncState.syncing = false;
      this._syncState.set(instanceId, syncState);
      return false;
    } finally {
      API.invalidateCache();
    }
  },
  
  // ================== GLOBAL METHODS (Landing Pages) ==================
  
  /**
   * Setup Global Event Delegation (Trigger Handlers)
   * Migrated from edm-bundle-builder-bb-LEGACY.js initGlobalBundleBuilder()
   */
  _setupGlobalEventDelegation: function() {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    
    // Idempotente Initialisierung: Prüfe ob bereits initialisiert
    if (document[Config.INIT_FLAGS.EVENT_DELEGATION_SETUP]) {
      console.log('[Bundle Builder] Event delegation already set up, skipping...');
      return;
    }
    
    console.log('[Bundle Builder] Setting up global event delegation...', {
      triggers: document.querySelectorAll(Config.SELECTORS.TRIGGER).length,
      globalSheet: !!document.getElementById(Config.SELECTORS.SHEET_GLOBAL.replace('#', ''))
    });
    
    // Event-Delegation auf document-Ebene (nur einmal registrieren)
    document.addEventListener('click', (e) => {
      // PRIORITY 1: Suche nach spezifischen Booster-Triggers
      const trigger = e.target.closest(Config.SELECTORS.TRIGGER);
      
      if (trigger) {
        // HARD BYPASS: Verhindere ALLE Standard-Aktionen
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.(); // Verhindert auch andere Listener
        
        const productId = trigger.dataset.productId;
        const productHandle = trigger.dataset.productHandle;
        
        console.log('[Bundle Builder] Booster trigger clicked', {
          trigger: trigger,
          productId: productId,
          productHandle: productHandle,
          isMobile: Utils.isMobile()
        });
        
        if (!productId && !productHandle) {
          console.error('[Bundle Builder] No product ID or handle found on trigger', trigger);
          return;
        }
        
        // Warnung wenn Handle fehlt aber ID vorhanden ist (defensive)
        if (!productHandle && productId) {
          console.warn('[Bundle Builder] Handle missing, using ID fallback. This may cause 404 errors. Product ID:', productId);
        }
        
        // DESKTOP LP FIX: Desktop LP funktioniert nicht (öffnet Mobile Sheet)
        // Lösung: Weiterleitung zur PDP statt Bundle Builder zu öffnen
        // Mobile LP: Verwendet weiterhin _handleLandingPageTrigger() (Bottom Sheet)
        if (!Utils.isMobile()) {
          // Desktop: Weiterleitung zur PDP
          if (productHandle) {
            this._redirectToPDP(productHandle);
          } else {
            console.error('[Bundle Builder] Desktop LP: Cannot redirect - productHandle is missing');
          }
          return; // WICHTIG: Verhindere weitere Event-Propagation
        }
        
        // Mobile: Unified Engine Strategy - Use State + MobileManager for all triggers
        // Both mobile and desktop now use the same bottom sheet with responsive grid
        // NOTE: Desktop LP is redirected to PDP (see above), so this is mobile-only now
        this._handleLandingPageTrigger(productId, productHandle);
        
        return; // WICHTIG: Verhindere weitere Event-Propagation
      }
      
    }, { capture: true, passive: false }); // CAPTURE: true für frühere Event-Interception
    
    document[Config.INIT_FLAGS.EVENT_DELEGATION_SETUP] = true;
    console.log('[Bundle Builder] Event delegation set up successfully with capture phase');
  },
  
};


// Auto-initialize on load
window.EdumonBundle.Controller.init();

